// extracted by mini-css-extract-plugin
export var attention = "style-module--attention--d3e3b";
export var content = "style-module--content--fcc11";
export var image = "style-module--image--37fb8";
export var item = "style-module--item--9a238";
export var list = "style-module--list--3758c";
export var title = "style-module--title--b9460";
export var wrapper = "style-module--wrapper--cab48";